<template>
  <div
    :class="[
      $options.name,
      'tw:hidden tw:sm:flex tw:py-3 tw:mx-4 tw:justify-center tw:items-center tw:gap-4 tw:border-b tw:border-default-200 tw:bg-white',
    ]"
  >
    <div class="tw:me-auto tw:w-full">
      <MainLayoutSearchBar />
    </div>

    <LiveStormEvents v-if="!isMobile" :show="true" />

    <div class="tw:flex tw:items-center tw:gap-4">
      <EngagementRateStatus v-if="isDev && isPaying" />
      <PackageManagerStatus
        :channel-type-id="CHANNEL_TYPE.SMS"
        @open-package-manager="openSMS"
      >
        <template #icon>
          <FontAwesomeIcon icon="fa-solid fa-message-sms" class="tw:text-black tw:text-xl" />
        </template>
      </PackageManagerStatus>
      <PackageManagerStatus
        :channel-type-id="CHANNEL_TYPE.WHATSAPP"
        @open-package-manager="openWhatsapp"
      >
        <template #icon>
          <svg width="20" height="20" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M9 0C4.03 0 0 4.03 0 9C0 10.66 0.44 12.22 1.22 13.56L0 18L4.56 16.8C5.86 17.52 7.38 18 9 18C13.97 18 18 13.97 18 9C18 4.03 13.97 0 9 0Z" fill="url(#whatsapp-gradient)" stroke="white" stroke-width="1"/>
            <path d="M13.07 10.85C12.82 10.72 11.58 10.11 11.35 10.03C11.12 9.95 10.95 9.91 10.78 10.16C10.61 10.41 10.13 10.98 9.98 11.15C9.83 11.32 9.68 11.34 9.43 11.21C9.18 11.08 8.36 10.81 7.39 9.94C6.64 9.27 6.13 8.44 5.98 8.19C5.83 7.94 5.96 7.81 6.09 7.68C6.21 7.56 6.34 7.37 6.47 7.22C6.6 7.07 6.64 6.96 6.72 6.79C6.8 6.62 6.76 6.47 6.7 6.34C6.64 6.21 6.14 4.97 5.94 4.47C5.74 3.98 5.54 4.05 5.39 4.04C5.24 4.03 5.07 4.03 4.9 4.03C4.73 4.03 4.46 4.09 4.23 4.34C4 4.59 3.35 5.2 3.35 6.44C3.35 7.68 4.25 8.88 4.38 9.05C4.51 9.22 6.13 11.78 8.65 12.87C11.17 13.96 11.17 13.63 11.63 13.59C12.09 13.55 13.13 12.98 13.33 12.39C13.53 11.8 13.53 11.3 13.46 11.19C13.39 11.08 13.24 11.02 13.07 10.85Z" fill="white"/>
            <defs>
              <linearGradient id="whatsapp-gradient" x1="9" y1="0" x2="9" y2="18" gradientUnits="userSpaceOnUse">
                <stop stop-color="#57D163"/>
                <stop offset="1" stop-color="#23B33A"/>
              </linearGradient>
            </defs>
          </svg>
        </template>
      </PackageManagerStatus>
    </div>

    <div class="tw:flex tw:items-center tw:gap-2">
      <NotificationsMenu />
      <EdroneButtonIcon
        :tooltip="trans._menu.topBar.buttons.news"
        class="beamerTrigger"
        type="plain"
        unique-id="main-top-bar__beamer-button"
      >
        <FontAwesomeIcon class="tw:text-2xl" icon="fa-light fa-megaphone" />
      </EdroneButtonIcon>
      <EdroneButtonIcon
        :tooltip="trans._menu.topBar.buttons.help"
        type="plain"
        unique-id="main-top-bar__help-button"
        @click="handleClickHelp"
      >
        <FontAwesomeIcon class="tw:text-2xl" icon="fa-light fa-circle-question" />
      </EdroneButtonIcon>
      <EdroneButtonIcon
        :tooltip="trans._menu.topBar.buttons.canny"
        type="plain"
        unique-id="main-top-bar__canny-button"
        @click="handleCannyHelp"
      >
        <FontAwesomeIcon class="tw:text-2xl" icon="fa-light fa-lightbulb-exclamation" />
      </EdroneButtonIcon>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { computed } from "vue";
import { useStore } from "vuex";
import EdroneButtonIcon from "edrone-components/EdroneButtonIcon.vue";
import NotificationsMenu from "vue-app/components/NotificationsMenu/NotificationsMenu.vue";
import MainLayoutSearchBar from "./MainLayoutSearchBar.vue";
import LiveStormEvents from "vue-app/components/LiveStormEvents/LiveStormEvents.vue";
import PackageManagerStatus from "vue-app/components/PackageManager/PackageManagerStatus.vue";
import EngagementRateStatus from "vue-app/components/EngagementRateStatus/EngagementRateStatus.vue";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { CHANNEL_TYPE } from "vue-app/types/enums";
import { usePackageManager } from "vue-app/composables/usePackageManager";

const { openWhatsapp, openSMS } = usePackageManager();

const store = useStore();
const isMobile = computed(() => store.getters["global/isMobile"]);

function handleClickHelp() {
  window.open(window._trans["support_link"], "_blank");
}

function handleCannyHelp() {
  window.open("https://edrone.canny.io/", "_blank");
}

const isDev = window.EDRONE_CONTEXT.user.isDev;
const isPaying = window.EDRONE_CONTEXT.tracker.isPaying;
const trans = window._trans;

</script>
